<div
  class="template-field"
  [class]="ignoreClicksClass"
  [class.template-field--focused]="inFocus()?.value"
>
  <div class="template-field__input">
    <input
      #searchInput
      type="text"
      role="combobox"
      autocomplete="off"
      aria-autocomplete="list"
      [id]="fieldKey"
      [name]="fieldKey"
      [placeholder]="searchPlaceholder"
      [attr.aria-expanded]="showOptions()"
      [attr.aria-controls]="listId"
      [attr.aria-activedescendant]="activeRowId()"
      [ngModel]="query()"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onQueryChange($event)"
      (click)="openOptions()"
      (focus)="fieldFocus.emit()"
      (keydown)="onKeyDown($event)"
    />

    @if (query()) {
      <button
        type="button"
        class="template-field__clear"
        [attr.aria-label]="'TRANS__SEARCH__CLEAR_SEARCH' | translate"
        (click)="clearField()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }

    <button
      type="button"
      tabindex="-1"
      aria-hidden="true"
      class="template-field__toggle"
      [class.template-field__toggle--open]="showOptions()"
      (click)="toggleOptions()"
    >
      <span class="template-field__divider"></span>

      <mat-icon>expand_more</mat-icon>
    </button>
  </div>

  @if (showOptions()) {
    <div class="template-field__options" role="tree" [id]="listId">
      @if (loading()) {
        <div class="template-field__message">
          <mat-spinner color="accent" diameter="16"></mat-spinner>

          <span>{{ 'TRANS__SEARCH__LOADING_INFO' | translate }}</span>
        </div>
      } @else if (!rows().length) {
        <div class="template-field__message template-field__message--empty">
          @if (query()) {
            <span>{{ 'TRANS__FIELD_SELECT_OPTIONS__NO_SEARCH_RESULT' | translate }}</span>
          } @else {
            <span>{{ 'TRANS__FIELD_SELECT_OPTIONS__NO_AVAILABLE_OPTIONS' | translate }}</span>
          }
        </div>
      } @else {
        @for (row of rows(); track row.id; let index = $index) {
          <div
            #rowItem
            role="treeitem"
            class="template-field__row"
            [id]="row.id"
            [class.template-field__row--group]="row.isGroup"
            [class.template-field__row--child]="row.field.level > 0"
            [class.template-field__row--active]="index === activeIndex()"
            [attr.aria-level]="row.field.level + 1"
            [attr.aria-expanded]="row.isGroup ? row.expanded : null"
            [attr.aria-selected]="row.isGroup ? null : index === activeIndex()"
            (mouseenter)="activeIndex.set(index)"
            (click)="activateRow(row)"
          >
            @if (row.isGroup) {
              <mat-icon class="template-field__expander" aria-hidden="true">{{ row.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            }
            <span class="template-field__row-name">{{ row.field.field_title }}</span>
          </div>
        }
      }
    </div>
  }
</div>
